var Apidae_Nav = (function(){
    var self = {};

    self.nav = function(){

        var container = document.getElementById( 'bb-container' ),
            wrapper = container.querySelector( 'div.bb-wrapper' ),
            sections = Array.prototype.slice.call( wrapper.querySelectorAll( '.bb-section' ) ),
            links = Array.prototype.slice.call( container.querySelectorAll( '.bb-header > ul.bb-nav > li' ) ),
            sectionsCount = sections.length,
            transEndEventNames = {
                'WebkitTransition': 'webkitTransitionEnd',
                'MozTransition': 'transitionend',
                'OTransition': 'oTransitionEnd',
                'msTransition': 'MSTransitionEnd',
                'transition': 'transitionend'
            },
            transEndEventName = transEndEventNames[Modernizr.prefixed( 'transition' )],
            eventtype = mobilecheck() ? 'touchstart' : 'click';

        //if(loadData === false && container.length){
            loadData = true;
            // add navigation elements
            if( sectionsCount >= 3 && Modernizr.csstransforms3d ) {
                var current = 0,
                    isAnimating = false;

                classie.add( container, 'bb-triplelayout' );

                function createNavigation() {
                    var navL = document.createElement( 'div' ),
                        navR = document.createElement( 'div' ),
                        sidenav = document.createElement( 'nav' );

                    navL.className = 'bb-sidenav-left';
                    navR.className = 'bb-sidenav-right';
                    sidenav.className = 'bb-sidenav';

                    sidenav.appendChild( navL );
                    sidenav.appendChild( navR );
                    container.insertBefore( sidenav, wrapper.nextSibling );

                    navL.addEventListener( eventtype, function() { navigate( 'left' ) } );
                    navR.addEventListener( eventtype, function() { navigate( 'right' ) } );
                }

                function cleanClasses() {
                    sections.forEach( function( el, i ) {
                        el.className = '';
                    } );
                    links.forEach( function( el, i ) {
                        el.className = '';
                    } );
                }

                function navigate( dir ) {
                    if( isAnimating ) {
                        return false;
                    }
                    isAnimating = true;

                    var invDir = dir === 'right' ? 'left' : 'right';
                    classie.add( container, 'bb-move-' + invDir );

                    var l = current === 0 ? sectionsCount - 1 : current - 1,
                        r = current < sectionsCount - 1 ? current + 1 : 0,
                        nextE;

                    if( dir === 'right' ) {
                        nextE = r < sectionsCount - 1 ? r + 1 : 0;
                    }
                    else if( dir === 'left' ) {
                        nextE = l > 0 ? l - 1 : sectionsCount - 1;
                    }

                    var nextSection = sections[ nextE ],
                        nextLink = links[ nextE ];
                    // clean classes
                    nextSection.className = '';
                    nextLink.className = '';
                    classie.add( nextSection, 'bb-' + dir + '-outer' );
                    classie.add( nextLink, 'bb-nav-' + dir + '-outer' );

                    var onTransitionEndFn = function() {
                        nextSection.removeEventListener( transEndEventName, onTransitionEndFn );
                        // clean classes
                        cleanClasses();

                        if( dir === 'right' ) {
                            classie.add( sections[ current ], 'bb-left' );
                            classie.add( sections[ r ], 'bb-current' );
                            classie.add( nextSection, 'bb-right' );

                            classie.add( links[ current ], 'bb-nav-left' );
                            classie.add( links[ r ], 'bb-nav-current' );
                            classie.add( nextLink, 'bb-nav-right' );

                            current = current < sectionsCount - 1 ? current + 1 : 0;
                        }
                        else if( dir === 'left' ) {
                            classie.add( nextSection, 'bb-left' );
                            classie.add( sections[ l ], 'bb-current' );
                            classie.add( sections[ current ], 'bb-right' );

                            classie.add( nextLink, 'bb-nav-left' );
                            classie.add( links[ l ], 'bb-nav-current' );
                            classie.add( links[ current ], 'bb-nav-right' );

                            current = current > 0 ? current - 1 : sectionsCount - 1;
                        }

                        classie.remove( container, 'bb-move-' + invDir );
                        isAnimating = false;
                    }

                    nextSection.addEventListener( transEndEventName, onTransitionEndFn );
                }

                // assign the current, left and right classes to the respective sections
                classie.add( sections[ current ], 'bb-current' );
                classie.add( sections[ current + 1 ], 'bb-right' );
                classie.add( sections[ sectionsCount - 1 ], 'bb-left' );
                // same for the header links
                classie.add( links[ current ], 'bb-nav-current' );
                classie.add( links[ current + 1 ], 'bb-nav-right' );
                classie.add( links[ sectionsCount - 1 ], 'bb-nav-left' );

                // create navigation structure
                //createNavigation();

                // click / touch events for the links
                links.forEach( function( el, i ) {
                    el.addEventListener( eventtype, function( ev ) {
                        ev.preventDefault();
                        if( classie.has( el, 'bb-nav-right' ) ) {
                            navigate( 'right' );
                        }
                        else if ( classie.has( el, 'bb-nav-left' ) ) {
                            navigate( 'left' );
                        }
                        else {
                            return false;
                        }
                    } )
                } );

                // add keyboard events
                /*document.addEventListener( 'keydown', function( ev ) {
                    var keyCode = ev.keyCode || ev.which,
                        arrow = {
                            left: 37,
                            right: 39
                        };
                    switch (keyCode) {
                        case arrow.left :
                            navigate( 'left' );
                            break;
                        case arrow.right :
                            navigate( 'right' );
                            break;
                    }
                } );*/

                // add swipe events
                /*if( mobilecheck() ) {
                    Hammer( container ).on( 'swipeleft', function( ev ) {
                        navigate( 'right' );
                    });

                    Hammer( container ).on( 'swiperight', function( ev ) {
                        navigate( 'left' );
                    });
                }*/

                loadData = false;

            }
        //}
    };

    self.init = function(){

        self.nav();
    };

    return self;
})();

$(window).load(function(){
    if($('#bb-container').length) {
        Apidae_Nav.init();
    }
});